export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const backIcon = require("../assets/backIcon.png");
export const bgImg = require("../assets/bg_image.jpg");
export const rightIcon = require("../assets/rightIcon.png");
